<div class="kota">
  <app-site-header />

  <main>
    <section class="hero">
      <div class="kota-container hero__grid kota-enter-seq">
        <div class="hero__content">
          <p class="hero__tag">Nueva Colección 2026</p>
          <h1 class="hero__title">Diseño para Vivir Mejor</h1>
          <p class="hero__subtitle">
            Descubre nuestra colección de recámaras y muebles diseñados con materiales premium para transformar tu
            hogar.
          </p>
          <div class="hero__ctas">
            <a href="#" class="btn btn--primary" (click)="noopClick($event)">
              Explorar
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
            <a routerLink="/catalogo" class="btn btn--outline">Ver Catálogo</a>
          </div>
        </div>

        <div class="hero__visual">
          <div class="hero__images">
            <img
              class="hero__img-main"
              src="https://images.unsplash.com/photo-1663811397302-8268848ca312?auto=format&fit=crop&w=960&q=80"
              width="480"
              height="400"
              alt="Interior con muebles modernos"
              loading="eager"
            />
            <img
              class="hero__img-small"
              src="https://images.unsplash.com/photo-1559841771-599b6eeaca62?auto=format&fit=crop&w=480&q=80"
              width="200"
              height="240"
              alt="Detalle de decoración"
              loading="lazy"
            />
          </div>
          <div class="hero__stats">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--kota-accent)" stroke-width="2">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
            </svg>
            <span>15K+ Clientes Felices</span>
          </div>
        </div>
      </div>
    </section>

    <section class="categories">
      <div class="kota-container">
        <div class="section-head">
          <div>
            <p class="section-label">Categorías</p>
            <h2 class="section-title">Explora Nuestras Colecciones</h2>
          </div>
          <a routerLink="/catalogo" class="section-link">
            Ver todo
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </a>
        </div>

        <div class="cat-grid kota-enter-stagger">
          @for (cat of categories(); track cat.title) {
            <article class="cat-card">
              <div class="cat-card__image-wrap">
                <img [src]="cat.image" [alt]="cat.title" width="400" height="280" loading="lazy" />
              </div>
              <div class="cat-card__body">
                <h3 class="cat-card__title">{{ cat.title }}</h3>
                <p class="cat-card__count">{{ cat.count }}</p>
              </div>
            </article>
          }
        </div>
      </div>
    </section>

    <section class="featured">
      <div class="kota-container">
        <div class="section-head section-head--solo">
          <div>
            <p class="section-label">Más Vendidos</p>
            <h2 class="section-title">Productos Destacados</h2>
          </div>
        </div>

        <div class="prod-grid kota-enter-stagger">
          @for (p of featured(); track p.slug) {
            <a class="prod-card prod-card--link" [routerLink]="['/producto', p.slug]">
              <div class="prod-card__image-wrap">
                <img [src]="p.image" [alt]="p.name" width="300" height="260" loading="lazy" />
                @if (p.tag) {
                  <span class="prod-card__tag">{{ p.tag }}</span>
                }
              </div>
              <div class="prod-card__info">
                <h3 class="prod-card__name">{{ p.name }}</h3>
                <div class="prod-card__prices">
                  <span class="prod-card__price">{{ p.price }}</span>
                  @if (p.oldPrice) {
                    <span class="prod-card__old">{{ p.oldPrice }}</span>
                  }
                </div>
              </div>
            </a>
          }
        </div>
      </div>
    </section>

    <section class="benefits">
      <div class="kota-container benefits__inner kota-enter-stagger">
        @for (b of benefits; track b.title) {
          <article class="benefit">
            <div class="benefit__icon-wrap" [attr.aria-hidden]="true">
              @switch (b.icon) {
                @case ('truck') {
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--kota-accent)" stroke-width="2">
                    <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
                    <path d="M15 18H9" />
                    <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" />
                    <circle cx="17" cy="18" r="2" />
                    <circle cx="7" cy="18" r="2" />
                  </svg>
                }
                @case ('shield') {
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--kota-accent)" stroke-width="2">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                    <path d="m9 12 2 2 4-4" />
                  </svg>
                }
                @case ('card') {
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--kota-accent)" stroke-width="2">
                    <rect width="20" height="14" x="2" y="5" rx="2" />
                    <path d="M2 10h20" />
                  </svg>
                }
                @case ('refresh') {
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--kota-accent)" stroke-width="2">
                    <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
                    <path d="M21 3v5h-5" />
                    <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
                    <path d="M8 16H3v5" />
                  </svg>
                }
              }
            </div>
            <h3 class="benefit__title">{{ b.title }}</h3>
            <p class="benefit__desc">{{ b.description }}</p>
          </article>
        }
      </div>
    </section>
  </main>
</div>
